import React from 'react';

const VideoGridPage = () => {
  return (
    <div className="container section">
      <h1>Video Library</h1>
      <p>Browse our collection of educational videos.</p>
    </div>
  );
};

export default VideoGridPage;
